import {
	AccountIcon,
	ArrowLeftBoldIcon,
	ArrowLeftIcon,
	ArrowRightThickIcon,
	BrainIcon,
	CheckAllIcon,
	CheckIcon,
	CloseBoxOutlineIcon,
	CloseCircleOutlineIcon,
	CogIcon,
	ConsoleIcon,
	ContentDuplicateIcon,
	DotsHorizontal,
	DownloadBoxIcon,
	EyeOutlineIcon,
	FileExportOutlineIcon,
	FileImportIcon,
	FileTreeIcon,
	FilterIcon,
	FolderIcon,
	FolderMultiplePlusIcon,
	ForumIcon,
	GestureTapIcon,
	HelpIcon,
	HomeIcon,
	HumanWalkerIcon,
	InformationIcon,
	InformationVariantIcon,
	LockOpenOutlineIcon,
	OfficeBuildingPlusIcon,
	PencilIcon,
	PlusIcon,
	RecycleVariantIcon,
	RefreshIcon,
	RestoreIcon,
	ShieldAccountIcon,
	SitemapIcon,
	SquareEditOutlineIcon,
	StopCircleIcon,
	SwapVerticalBoldIcon,
	SyncIcon,
	ThumbUpIcon,
	TrashIcon,
	UploadBoxIcon,
} from '@/shared/dynamicImports';
import { Button } from './Button';
import Tooltip from './Tooltip';

const ToolTipButton = ({
	dir,
	text,
	variant,
	size,
	iconType,
	handleSubmit,
	iconText,
	space,
	as,
	to,
	tooltipText,
	...rest
}) => {
	const renderIcon = () => {
		switch (iconType) {
			case 'create':
				return <PlusIcon data-testid="icon" />;
			case 'update':
				return <PencilIcon data-testid="icon" />;
			case 'delete':
				return <TrashIcon data-testid="icon" />;
			case 'sync':
			case 'recover':
				return <SyncIcon data-testid="icon" />;
			case 'refresh':
				return <RefreshIcon data-testid="icon" />;
			case 'settings':
				return <CogIcon data-testid="icon" />;
			case 'information':
				return <InformationIcon data-testid="icon" />;
			case 'export':
				return <FileExportOutlineIcon data-testid="icon" />;
			case 'import':
				return <FileImportIcon data-testid="icon" />;
			case 'pencil':
				return <PencilIcon data-testid="icon" />;
			case 'backBold':
				return <ArrowLeftBoldIcon data-testid="icon" />;
			case 'download':
				return <DownloadBoxIcon data-testid="icon" />;
			case 'upload':
				return <UploadBoxIcon data-testid="icon" />;
			case 'attachCompany':
				return <OfficeBuildingPlusIcon data-testid="icon" />;
			case 'folder':
				return <FolderIcon data-testid="icon" />;
			case 'editOutline':
				return <SquareEditOutlineIcon data-testid="icon" />;
			case 'updateRole':
				return <DotsHorizontal data-testid="icon" />;
			case 'account':
				return <AccountIcon data-testid="icon" />;
			case 'retire':
				return <HumanWalkerIcon data-testid="icon" />;
			case 'rightArrow':
				return <ArrowRightThickIcon data-testid="icon" />;
			case 'console':
				return <ConsoleIcon data-testid="icon" />;
			case 'stop':
				return <StopCircleIcon data-testid="icon" />;
			case 'permission':
				return <SitemapIcon data-testid="icon" />;
			case 'selectAll':
				return <CheckAllIcon data-testid="icon" />;
			case 'deselectAll':
				return <CloseBoxOutlineIcon data-testid="icon" />;
			case 'back':
				return <ArrowLeftIcon data-testid="icon" />;
			case 'admin':
				return <ShieldAccountIcon data-testid="icon" />;
			case 'filter':
				return <FilterIcon data-testid="icon" />;
			case 'close':
				return <CloseCircleOutlineIcon data-testid="icon" />;
			case 'recycle':
				return <RecycleVariantIcon data-testid="icon" />;
			case 'home':
				return <HomeIcon data-testid="icon" />;
			case 'duplicateFolder':
				return <FolderMultiplePlusIcon data-testid="icon" />;
			case 'duplicateFile':
				return <ContentDuplicateIcon data-testid="icon" />;
			case 'move':
				return <SwapVerticalBoldIcon data-testid="icon" />;
			case 'guide':
				return <BrainIcon data-testid="icon" />;
			case 'info':
				return <InformationVariantIcon data-testid="icon" />;
			case 'help':
				return <HelpIcon data-testid="icon" />;
			case 'action':
				return <GestureTapIcon data-testid="icon" />;
			case 'sub':
				return <FileTreeIcon data-testid="icon" />;
			case 'check':
				return <CheckAllIcon data-testid="icon" />;
			case 'eye':
				return <EyeOutlineIcon data-testid="icon" />;
			case 'unlock':
				return <LockOpenOutlineIcon data-testid="icon" />;
			case 'prevResponses':
				return <ForumIcon data-testid="icon" />;
			case 'submit':
				return <ThumbUpIcon data-testid="icon" />;
			case 'restore':
				return <RestoreIcon data-testid="icon" />;
			case 'solution':
				return <CheckIcon data-testid="icon" />;
			default:
				return null;
		}
	};

	return text ? (
		<Tooltip dir={dir} text={text} variant={variant}>
			<Button
				variant={variant}
				size={size}
				type="submit"
				space={space}
				onClick={handleSubmit}
				{...rest}
			>
				{renderIcon()}
				{iconText}
			</Button>
		</Tooltip>
	) : tooltipText ? (
		<Tooltip dir={dir} text={tooltipText} variant={variant}>
			<Button
				variant={variant}
				size={size}
				type="submit"
				space={space}
				onClick={handleSubmit}
				as={as}
				to={to}
				{...rest}
			>
				{renderIcon()}
				{iconText}
			</Button>
		</Tooltip>
	) : (
		<Button
			variant={variant}
			size={size}
			type="submit"
			space={space}
			onClick={handleSubmit}
			as={as}
			to={to}
			{...rest}
		>
			{renderIcon()}
			{iconText}
		</Button>
	);
};

export default ToolTipButton;
